import { render } from "./SVGUndo.vue?vue&type=template&id=f456f68c"
import script from "./SVGUndo.vue?vue&type=script&lang=js"
export * from "./SVGUndo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__